import React from 'react'
import * as regl from 'regl'
import './styles.scss'
import * as mat4 from 'gl-mat4'
import * as d3 from 'd3'

const isMobile = window.innerWidth < 800

const margin = {
  top: isMobile ? 0 : 0,
  right: isMobile ? 0 : 0,
  bottom: isMobile ? 0 : 0,
  left: isMobile ? 0 : 0
}

const dpi = window.devicePixelRatio

const NUM_POINTS = 42031
const VERT_SIZE = 4 * (4 + 4 + 4 + 4 + 1 + 4 + 4)

const randomBarbers = [
  29793,
  38537,
  29891,
  31782,
  40608,
  31263,
  35153,
  41334,
  28930,
  41486,
  30172,
  31853,
  36561,
  31257,
  37256,
  33094,
  33911,
  39706
]
const randomDvd = [
  4877,
  6819,
  2727,
  4779,
  2857,
  4581,
  12017,
  14559,
  14961,
  15357,
  14318,
  13438,
  14986,
  14912,
  9369,
  13512,
  10910,
  12714,
  11762,
  9700,
  9253,
  12171,
  14511,
  15739,
  12091,
  12968,
  14557,
  14796,
  10422,
  12226,
  25948,
  19704,
  17432,
  23723,
  21602,
  19765,
  20264,
  25400,
  22471,
  17624,
  23054,
  25375,
  16600,
  22045,
  16327,
  19620,
  17645,
  24505,
  24209
]

const labels = [
  require('./labels_groups_0_out.csv'),
  require('./labels_groups_1_out.csv'),
  require('./labels_groups_3_out.csv'),
  require('./labels_groups_2_out.csv'),
  require('./labels_groups_4_out.csv')
]

const labelsGroups = [
  {
    labels: labels[0],
    points: Array.from(Array(labels[0].length), (_, x) => x)
  },
  {
    labels: labels[1],
    points: Array.from(Array(labels[1].length), (_, x) => 20001 + x)
  },
  { labels: labels[2], points: [...randomDvd] },
  { labels: labels[3], points: [...randomBarbers] },
  {
    labels: labels[4],
    points: Array.from(Array(labels[4].length), (_, x) => 41931 + x)
  }
]

const points = Array(NUM_POINTS)
  .fill()
  .map(() => {
    const u = Math.random()
    const v = Math.random()
    const theta = u * 2.0 * Math.PI
    const phi = Math.acos(2.0 * v - 1.0)
    const r = Math.cbrt(Math.random() * 17)
    const sinTheta = Math.sin(theta)
    const cosTheta = Math.cos(theta)
    const sinPhi = Math.sin(phi)
    const cosPhi = Math.cos(phi)
    const x = r * sinPhi * cosTheta
    const y = r * sinPhi * sinTheta
    const z = r * cosPhi

    return [
      // Position start
      x,
      y,
      z,
      1,
      // Position end
      x,
      y,
      z,
      1,
      // Color start
      13 / 255,
      16 / 255,
      19 / 255,
      0,
      // Color end
      13 / 255,
      16 / 255,
      19 / 255,
      0.35,
      // Size
      4 * dpi,
      // freq
      Math.random() * 2,
      Math.random() * 2,
      Math.random() * 2,
      Math.random() * 2,
      // phase
      2.0 * Math.PI * Math.random(),
      2.0 * Math.PI * Math.random(),
      2.0 * Math.PI * Math.random(),
      2.0 * Math.PI * Math.random()
    ]
  })

//  const startView = [[], [10, 1, 10], [0, 0, 0], [0, 1, 0]]
//   const endView = [[], [10, 1, 10], [0, 0, 0], [0, 1, 0]]

// const view = {
//   start: [[], [...startView[1]], [...startView[2]], [...startView[3]]],
//   end: [[], [...endView[1]], [...endView[2]], [...endView[2]]],
//   originStart: [[], [...startView[1]], [...startView[2]], [...startView[3]]],
//   originEnd: [[], [...endView[1]], [...endView[2]], [...endView[3]]]
// }

const view = {
  start: [[], [10, 1, 10], [0, 0, 0], [0, 1, 0]],
  end: [[], [10, 1, 10], [0, 0, 0], [0, 1, 0]],
  originStart: [[], [10, 1, 10], [0, 0, 0], [0, 1, 0]],
  originEnd: [[], [10, 1, 10], [0, 0, 0], [0, 1, 0]]
}

class DotsCanvasRegl extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      width: 200,
      height: 200,
      showCircles: false,
      showLabels: false,
      showHistoryMarkers: false
    }

    this.getDimensions = this.getDimensions.bind(this)
    this.updateDimensions = this.updateDimensions.bind(this)

    this.businessesGroupId = 0
    this.stage = {
      elapsedTime: -1,
      startTime: null,
      matrix: {
        perspective: null,
        lookAt: {
          start: null,
          end: null
        }
      },
      backgroundHsl: {
        current: [31 / 255, 35 / 255, 49 / 255],
        target: [31 / 255, 35 / 255, 49 / 255]
      },
      rotationAxis: 1,
      rotationSpeed: 0.005,
      selectedPointIndex: 0
    }
    this.scrollY = 0
    this.chronoHeight = 0
    this.chronoGroups = [
      [5, 0],
      [18, 0],
      [72, 0],
      [234, 0],
      [633, 0],
      [1709, 0],
      [4642, 0],
      [8464, 0],
      [11893, 0],
      [14361, 0]
    ]
  }

  componentDidMount() {
    // Initialize regl
    this.r = regl({
      canvas: this.canvas,
      extensions: ['OES_standard_derivatives']
    })

    // Initilize a buffer with a list of points
    this.pointBuffer = this.r.buffer(points)

    // Launch the animation loop
    this.r.frame(({ time, tick }) => {
      if (this.stage.startTime === null) {
        this.stage.startTime = time
      }

      // Animate the background color
      /* const cTarget = this.stage.backgroundHsl.target
      const cCurrent = this.stage.backgroundHsl.current

      const t = d3.easeCubicInOut((time - this.stage.startTime) / 5)

      this.stage.backgroundHsl.current = [
        (cCurrent[0] += (cTarget[0] - cCurrent[0]) * 0.5 * t),
        (cCurrent[1] += (cTarget[1] - cCurrent[1]) * 0.5 * t),
        (cCurrent[2] += (cTarget[2] - cCurrent[2]) * 0.5 * t)
      ] */

      this.r.clear({
        color: [
          this.stage.backgroundHsl.current[0],
          this.stage.backgroundHsl.current[1],
          this.stage.backgroundHsl.current[2],
          1
        ]
      })

      // Draw the points
      this.draw(tick, time)
    })

    // Get the proper canvas dimensions
    this.updateDimensions()
    // Adapt the canvas to the window ater a resize
    window.addEventListener('resize', this.updateDimensions)
  }

  componentWillReceiveProps(nextProps) {
    if ([1, 2, 3, 3001, 3002, 9].includes(nextProps.stage)) {
      this.setState({
        showLabels: true
      })
    } else {
      this.setState({
        showLabels: false
      })
    }

    if (nextProps.stage > 5 && nextProps.stage < 9) {
      this.setState({
        showCircles: true
      })
    } else {
      this.setState({
        showCircles: false
      })
    }

    if (
      (nextProps.stage >= 3 && nextProps.stage <= 4) ||
      nextProps.stage === 3001 ||
      nextProps.stage === 3002
    ) {
      this.setState({
        showHistoryMarkers: true
      })
    } else {
      this.setState({
        showHistoryMarkers: false
      })
    }
  }

  componentDidUpdate(prevProps) {
    console.log('')
    console.log('UPDATE')

    if (this.props.stage !== prevProps.stage) {
      switch (this.props.stage) {
        case 0:
          console.log('STAGE 0')
          this.stage.startTime = null

          view.start = view.end
          view.end = [[], [10, 1, 10], [0, 0, 0], [0, 1, 0]]
          // view.originStart = [...view.start]
          // view.originEnd = [...view.end]

          this.stage.rotationSpeed = 0.005
          this.stage.rotationAxis = 1

          points.map((p, i) => {
            p[0] = p[4]
            p[1] = p[5]
            p[2] = p[6]

            p[8] = p[12]
            p[9] = p[13]
            p[10] = p[14]
            p[11] = p[15]

            const u = Math.random()
            const v = Math.random()
            const theta = u * 2.0 * Math.PI
            const phi = Math.acos(2.0 * v - 1.0)
            const r = Math.cbrt(Math.random() * 17)
            const sinTheta = Math.sin(theta)
            const cosTheta = Math.cos(theta)
            const sinPhi = Math.sin(phi)
            const cosPhi = Math.cos(phi)
            const x = r * sinPhi * cosTheta
            const y = r * sinPhi * sinTheta
            const z = r * cosPhi

            p[4] = x
            p[5] = y
            p[6] = z

            p[12] = 13 / 255
            p[13] = 16 / 255
            p[14] = 19 / 255
            p[15] = 0.35
          })

          this.pointBuffer({
            data: points
          })

          break
        case 1:
          console.log('STAGE 1 - État des lieux')
          this.businessesGroupId = 0

          this.stage.startTime = null

          view.start = view.end
          view.end = [[], [10, 1, 10], [0, 0, 0], [0, 1, 0]]

          this.stage.rotationSpeed = 0.005
          this.stage.rotationAxis = 1

          points.map(p => {
            const u = Math.random()
            const v = Math.random()
            const theta = u * 2.0 * Math.PI
            const phi = Math.acos(2.0 * v - 1.0)
            const r = Math.cbrt(Math.random() * 2)
            const sinTheta = Math.sin(theta)
            const cosTheta = Math.cos(theta)
            const sinPhi = Math.sin(phi)
            const cosPhi = Math.cos(phi)
            const x = r * sinPhi * cosTheta
            const y = r * sinPhi * sinTheta
            const z = r * cosPhi

            p[0] = p[4]
            p[1] = p[5]
            p[2] = p[6]

            p[4] = x + (1 - Math.random() * 2)
            p[5] = y + (1 - Math.random() * 2)
            p[6] = z + (1 - Math.random() * 2)

            p[8] = p[12]
            p[9] = p[13]
            p[10] = p[14]
            p[11] = p[15]

            p[12] = 255 / 255
            p[13] = 255 / 255
            p[14] = 255 / 255
            p[15] = 0.1
            p[16] = 4 * dpi
          })

          this.pointBuffer({
            data: points
          })

          break
        case 2:
          console.log('STAGE 2 - Petites entreprises')
          this.businessesGroupId = 1

          this.stage.startTime = null

          view.start = view.end
          view.end = [[], [10, 1, 10], [0, 0, 0], [0, 1, 0]]

          this.stage.rotationSpeed = 0.01
          this.stage.rotationAxis = 1

          points.map((p, i) => {
            p[0] = p[4]
            p[1] = p[5]
            p[2] = p[6]

            p[8] = p[12]
            p[9] = p[13]
            p[10] = p[14]
            p[11] = p[15]

            if (i > 20000) {
              const u = Math.random()
              const v = Math.random()
              const theta = u * 2.0 * Math.PI
              const phi = Math.acos(2.0 * v - 1.0)
              const r = Math.cbrt(Math.random() * 0.5)
              const sinTheta = Math.sin(theta)
              const cosTheta = Math.cos(theta)
              const sinPhi = Math.sin(phi)
              const cosPhi = Math.cos(phi)
              const x = r * sinPhi * cosTheta
              const y = r * sinPhi * sinTheta
              const z = r * cosPhi

              p[4] = x + (0.5 - Math.random() * 1)
              p[5] = y + (0.5 - Math.random() * 1)
              p[6] = z + (0.5 - Math.random() * 1)

              p[12] = 234 / 255
              p[13] = 117 / 255
              p[14] = 190 / 255
              p[15] = 0.15
              p[16] = 4 * dpi
            } else {
              const u = Math.random()
              const v = Math.random()
              const theta = u * 2.0 * Math.PI
              const phi = Math.acos(2.0 * v - 1.0)
              const r = Math.cbrt(Math.random() * 100)
              const sinTheta = Math.sin(theta)
              const cosTheta = Math.cos(theta)
              const sinPhi = Math.sin(phi)
              const cosPhi = Math.cos(phi)
              const x = r * sinPhi * cosTheta
              const y = r * sinPhi * sinTheta
              const z = r * cosPhi

              p[4] = x
              p[5] = y
              p[6] = z

              p[12] = 29 / 255
              p[13] = 35 / 255
              p[14] = 39 / 255
              p[15] = 0.05
              p[16] = 4
            }
          })

          this.pointBuffer({
            data: points
          })
          break
        case 3: {
          console.log('STAGE 3 - Chronologie A')
          this.businessesGroupId = 2

          this.stage.startTime = null

          view.start = view.end
          view.end = [[], [0, 3, 10], [0, 3, 0], [0, 1, 0]]

          this.stage.rotationSpeed = 0.005
          this.stage.rotationAxis = 2

          const nrows = isMobile ? 50 : 100
          const spaceBetweenPoints = 0.035

          let ypos = 0
          let pindex = 0

          this.chronoGroups.forEach((g, i) => {
            let y = 0
            let x = 0
            let gi = 0

            for (let i = 0; i < g[0]; i++) {
              const p = points[pindex]
              x =
                (gi % nrows) * spaceBetweenPoints -
                (nrows / 2) * spaceBetweenPoints
              y = Math.floor(gi / nrows) * spaceBetweenPoints

              p[0] = p[4]
              p[1] = p[5]
              p[2] = p[6]

              p[4] = x
              p[5] = y + ypos + 2
              p[6] = 0

              p[8] = p[12]
              p[9] = p[13]
              p[10] = p[14]
              p[11] = p[15]

              p[12] = 255 / 255
              p[13] = 255 / 255
              p[14] = 255 / 255
              p[15] = 0.15
              p[16] = 4 * dpi

              p[17] = 0
              p[18] = 0
              p[19] = 0
              p[20] = 0
              p[21] = 0
              p[22] = 0
              p[23] = 0
              p[24] = 0

              if (randomBarbers.includes(pindex)) {
                p[12] = 234 / 255
                p[13] = 117 / 255
                p[14] = 190 / 255
                p[15] = 1
                p[16] = 6 * dpi
              }

              if (randomDvd.includes(pindex)) {
                p[12] = 255 / 255
                p[13] = 255 / 255
                p[14] = 255 / 255
                p[15] = 1
                p[16] = 6 * dpi
              }

              pindex += 1
              gi += 1
            }

            ypos += y + 0.25
            // console.log(i, ypos, pindex)
            this.chronoGroups[i][1] = ypos
          })

          this.pointBuffer({
            data: points
          })

          this.chronoHeight = ypos
          break
        }
        case 3001: {
          console.log('STAGE 3001 - Chronologie B')
          this.businessesGroupId = 2

          this.stage.startTime = null
          this.stage.rotationAxis = 0

          view.start = view.end
          view.end = [[], [0, 3, 10], [0, 3, 0], [0, 1, 0]]

          points.map((p, i) => {
            p[0] = p[4]
            p[1] = p[5]
            p[2] = p[6]

            p[8] = p[12]
            p[9] = p[13]
            p[10] = p[14]
            p[11] = p[15]
          })

          this.pointBuffer({
            data: points
          })
          break
        }
        case 3002: {
          console.log('STAGE 3002 - Chronologie C')
          this.businessesGroupId = 3
          this.stage.startTime = null
          this.stage.rotationAxis = 2

          view.start = view.end
          view.end = [
            [],
            [0, this.chronoHeight + 1, 10],
            [0, this.chronoHeight + 1, 0],
            [0, 1, 0]
          ]

          const nrows = isMobile ? 50 : 100
          const spaceBetweenPoints = 0.035

          let ypos = 0
          let pindex = 0

          this.chronoGroups.forEach((g, i) => {
            let y = 0
            let x = 0
            let gi = 0

            for (let i = 0; i < g[0]; i++) {
              const p = points[pindex]
              x =
                (gi % nrows) * spaceBetweenPoints -
                (nrows / 2) * spaceBetweenPoints
              y = Math.floor(gi / nrows) * spaceBetweenPoints

              p[0] = p[4]
              p[1] = p[5]
              p[2] = p[6]

              p[4] = x
              p[5] = y + ypos + 2
              p[6] = 0

              p[8] = p[12]
              p[9] = p[13]
              p[10] = p[14]
              p[11] = p[15]

              p[12] = 255 / 255
              p[13] = 255 / 255
              p[14] = 255 / 255
              p[15] = 0.15
              p[16] = 4 * dpi

              p[17] = 0
              p[18] = 0
              p[19] = 0
              p[20] = 0
              p[21] = 0
              p[22] = 0
              p[23] = 0
              p[24] = 0

              if (randomBarbers.includes(pindex)) {
                p[12] = 234 / 255
                p[13] = 117 / 255
                p[14] = 190 / 255
                p[15] = 1
                p[16] = 6 * dpi
              }

              if (randomDvd.includes(pindex)) {
                p[12] = 255 / 255
                p[13] = 255 / 255
                p[14] = 255 / 255
                p[15] = 1
                p[16] = 6 * dpi
              }

              pindex += 1
              gi += 1
            }

            ypos += y + 0.25
            // console.log(i, ypos, pindex)
            this.chronoGroups[i][1] = ypos
          })

          this.pointBuffer({
            data: points
          })

          this.chronoHeight = ypos
          break
        }
        case 5: {
          console.log('STAGE 5 - Groupes')
          this.stage.startTime = null

          view.start = view.end
          view.end = [[], [10, 1, 10], [0, 0, 0], [0, 1, 0]]

          this.stage.rotationSpeed = 0.01
          this.stage.rotationAxis = 1

          const groups = [
            50,
            25,
            25,
            100,
            100,
            200,
            500,
            1000,
            200,
            200,
            200,
            200,
            200,
            50,
            10,
            10,
            10,
            10,
            10,
            50,
            50,
            300,
            500,
            1000,
            5000,
            5000,
            5000,
            2500,
            2500,
            2500,
            2500,
            10000,
            2031
          ]
          let pindex = 0

          groups.forEach((g, gi) => {
            const groupRadius = Math.pow(g / 10000, 4)
            const groupPosition = [
              1 - Math.random() * 2,
              1 - Math.random() * 2,
              1 - Math.random() * 2
            ]

            for (let i = 0; i < g; i++) {
              const u = Math.random()
              const v = Math.random()
              const theta = u * 2.0 * Math.PI
              const phi = Math.acos(2.0 * v - 1.0)
              const r = Math.cbrt(Math.random() * Math.random() * groupRadius)
              const sinTheta = Math.sin(theta)
              const cosTheta = Math.cos(theta)
              const sinPhi = Math.sin(phi)
              const cosPhi = Math.cos(phi)
              const x = r * sinPhi * cosTheta
              const y = r * sinPhi * sinTheta
              const z = r * cosPhi

              const p = points[pindex]

              p[0] = p[4]
              p[1] = p[5]
              p[2] = p[6]

              p[8] = p[12]
              p[9] = p[13]
              p[10] = p[14]
              p[11] = p[15]

              p[4] = x + groupPosition[0]
              p[5] = y + groupPosition[1]
              p[6] = z + groupPosition[2]

              p[12] = 234 / 255
              p[13] = 117 / 255
              p[14] = 190 / 255
              p[15] = 0.05
              p[16] = 4 * dpi

              // freq & phase
              p[17] = Math.random() * 2
              p[18] = Math.random() * 2
              p[19] = Math.random() * 2
              p[20] = Math.random() * 2
              p[21] = 2.0 * Math.PI * Math.random()
              p[22] = 2.0 * Math.PI * Math.random()
              p[23] = 2.0 * Math.PI * Math.random()
              p[24] = 2.0 * Math.PI * Math.random()

              pindex += 1
            }
          })

          this.pointBuffer({
            data: points
          })
          break
        }
        case 6:
          console.log('STAGE 6 - Durée de vie A')
          this.stage.startTime = null

          view.start = view.end
          view.end = [[], [20, 0, 0], [0, 0, 0], [0, 1, 0]]

          this.stage.rotationSpeed = 0.0025
          this.stage.rotationAxis = 2

          points.map(p => {
            const angle = (Math.random() * 360 * Math.PI) / 180
            p[0] = p[4]
            p[1] = p[5]
            p[2] = p[6]

            p[4] = 0
            p[5] = Math.cos(angle) * (3.25 - Math.random() * 0.5)
            p[6] = Math.sin(angle) * (3.25 - Math.random() * 0.5)

            p[8] = p[12]
            p[9] = p[13]
            p[10] = p[14]
            p[11] = p[15]

            p[12] = 234 / 255
            p[13] = 117 / 255
            p[14] = 190 / 255
            p[15] = 0.1
            p[16] = 4 * dpi
          })

          this.pointBuffer({
            data: points
          })
          break
        case 7:
          console.log('STAGE 7 - Durée de vie B')
          this.stage.startTime = null

          view.start = view.end
          view.end = [[], [20, 0, 0], [0, 0, 0], [0, 1, 0]]

          this.stage.rotationSpeed = 0.0025
          this.stage.rotationAxis = 2

          points.map((p, i) => {
            // The sarting position is the last position
            p[0] = p[4]
            p[1] = p[5]
            p[2] = p[6]

            // the starting color is the last color
            p[8] = p[12]
            p[9] = p[13]
            p[10] = p[14]
            p[11] = p[15]

            if (i > 10826) {
              const angle = (Math.random() * 360 * Math.PI) / 180

              p[4] = 0
              p[5] = Math.cos(angle) * (1.9 - Math.random() * 0.85)
              p[6] = Math.sin(angle) * (1.9 - Math.random() * 0.85)

              p[12] = 234 / 255
              p[13] = 117 / 255
              p[14] = 190 / 255
              p[15] = 0.1
            } else {
              p[12] = 13 / 255
              p[13] = 16 / 255
              p[14] = 19 / 255
              p[15] = 0.3
            }
          })

          this.pointBuffer({
            data: points
          })
          break
        case 8:
          console.log('STAGE 8 - Durée de vie C')
          this.stage.startTime = null

          view.start = view.end
          view.end = [[], [20, 0, 0], [0, 0, 0], [0, 1, 0]]

          this.stage.rotationSpeed = 0.0025
          this.stage.rotationAxis = 2

          points.map((p, i) => {
            p[0] = p[4]
            p[1] = p[5]
            p[2] = p[6]

            p[8] = p[12]
            p[9] = p[13]
            p[10] = p[14]
            p[11] = p[15]

            if (i > 32348) {
              const u = Math.random()
              const v = Math.random()
              const theta = u * 2.0 * Math.PI
              const phi = Math.acos(2.0 * v - 1.0)
              const r = Math.cbrt(Math.random() * 0.5)
              const sinTheta = Math.sin(theta)
              const cosTheta = Math.cos(theta)
              const sinPhi = Math.sin(phi)
              const cosPhi = Math.cos(phi)
              const x = r * sinPhi * cosTheta
              const y = r * sinPhi * sinTheta
              const z = r * cosPhi

              p[4] = 0
              p[5] = y
              p[6] = z

              p[12] = 234 / 255
              p[13] = 117 / 255
              p[14] = 190 / 255
              p[15] = 0.1
            } else {
              p[12] = 13 / 255
              p[13] = 16 / 255
              p[14] = 17 / 255
              p[15] = 0.3
            }
          })

          this.pointBuffer({
            data: points
          })
          break
        case 9:
          console.log('STAGE 9 - Les plus vieilles')
          this.businessesGroupId = 4

          this.stage.startTime = null

          view.start = view.end
          view.end = [[], [8, 1, 10], [0, 0, 0], [0, 1, 0]]

          this.stage.rotationSpeed = 0.01
          this.stage.rotationAxis = 1

          points.map((p, i) => {
            p[0] = p[4]
            p[1] = p[5]
            p[2] = p[6]

            p[8] = p[12]
            p[9] = p[13]
            p[10] = p[14]
            p[11] = p[15]

            if (i > 41930) {
              const u = Math.random()
              const v = Math.random()
              const theta = u * 2.0 * Math.PI
              const phi = Math.acos(2.0 * v - 1.0)
              const r = Math.cbrt(Math.random() * 10)
              const sinTheta = Math.sin(theta)
              const cosTheta = Math.cos(theta)
              const sinPhi = Math.sin(phi)
              const cosPhi = Math.cos(phi)
              const x = r * sinPhi * cosTheta
              const y = r * sinPhi * sinTheta
              const z = r * cosPhi

              p[4] = x
              p[5] = y
              p[6] = z

              p[12] = 234 / 255
              p[13] = 117 / 255
              p[14] = 190 / 255
              p[15] = 1
              p[16] = 8 * dpi
            } else {
              const u = Math.random()
              const v = Math.random()
              const theta = u * 2.0 * Math.PI
              const phi = Math.acos(2.0 * v - 1.0)
              const r = Math.cbrt(Math.random() * 1000000)
              const sinTheta = Math.sin(theta)
              const cosTheta = Math.cos(theta)
              const sinPhi = Math.sin(phi)
              const cosPhi = Math.cos(phi)
              const x = r * sinPhi * cosTheta
              const y = r * sinPhi * sinTheta
              const z = r * cosPhi

              p[4] = x
              p[5] = y
              p[6] = z

              p[12] = 29 / 255
              p[13] = 35 / 255
              p[14] = 39 / 255
              p[15] = 0
            }
          })

          this.pointBuffer({
            data: points
          })
          break
        case 10:
          console.log('STAGE 10 - Fin')
          this.stage.startTime = null

          view.start = view.end
          view.end = [[], [8, 1, 10], [0, 0, 0], [0, 1, 0]]

          this.stage.rotationSpeed = 0.01
          this.stage.rotationAxis = 1

          points.map((p, i) => {
            p[0] = p[4]
            p[1] = p[5]
            p[2] = p[6]

            p[8] = p[12]
            p[9] = p[13]
            p[10] = p[14]
            p[11] = p[15]

            p[15] = 0
          })

          this.pointBuffer({
            data: points
          })
          break
      }

      // Draw the random label if necessary
      if (this.state.showLabels && this.label) {
        this.drawRandomLabel()
      }
    }

    console.log(this.props)
  }

  updateDimensions() {
    const newDimensions = this.getDimensions()

    this.setState(
      {
        width: newDimensions.w * dpi,
        height: newDimensions.h * dpi
      },
      () => {
        // Perpective
        this.stage.matrix.perspective = mat4.perspective(
          [], // out
          (25 * Math.PI) / 180, // fieldOfViewRadians
          this.state.width / this.state.height, // aspect
          0.01, // zNear
          1000 // zFar
        )

        this.r.poll()
      }
    )
  }

  getDimensions() {
    let width = this.canvas.parentNode.clientWidth - margin.left - margin.right
    let height =
      (!isMobile ? (width * 2) / 4 : width * 2) - margin.top - margin.bottom

    width = window.innerWidth
    height = window.innerHeight

    return {
      w: width,
      h: height
    }
  }

  draw(tick, time) {
    const drawParticles = this.r({
      depth: { enable: false },
      blend: {
        enable: true,
        func: {
          srcRGB: 'src alpha',
          srcAlpha: 'src color',
          dstRGB: 'one',
          dstAlpha: 'one'
        },
        equation: {
          rgb: 'add',
          alpha: 'add'
        },
        color: [0, 0, 0, 0]
      },

      vert: `
        precision mediump float;

        // per vertex attributes
        attribute vec4 positionStart, positionEnd;
        attribute vec4 colorStart, colorEnd;
        attribute vec4 freq, phase;
        attribute float size;

        // values that are the same for all vertices
        uniform float time;
        uniform mat4 viewStart, viewEnd, projection;
        uniform float elapsed;
        uniform float duration;

        // variables to send to the fragment shader
        varying vec4 fragColor;

        // helper function to handle cubic easing (copied from d3)
        // note there are premade ease functions available via glslify.
        float easeCubicInOut(float t) {
          t *= 2.0;
          t = (t <= 1.0 ? t * t * t : (t -= 2.0) * t * t + 2.0) / 2.0;
        
          if (t > 1.0) {
            t = 1.0;
          }
        
          return t;
        }

        void main() {
          float t = easeCubicInOut(time);
          highp vec4 position = mix(positionStart, positionEnd, t);
          mat4 view;

          // Orientation
          view[0] = mix(viewStart[0], viewEnd[0], t);
          view[1] = mix(viewStart[1], viewEnd[1], t);
          view[2] = mix(viewStart[2], viewEnd[2], t);
          // Position
          view[3] = mix(viewStart[3], viewEnd[3], t);

          position = position + cos(freq * elapsed * 0.1) * freq * 0.1;

          gl_PointSize = size;
          gl_Position = projection * view * position;
          fragColor = mix(colorStart, colorEnd, t);
        }`,

      frag: `
        #ifdef GL_OES_standard_derivatives
        #extension GL_OES_standard_derivatives : enable
        #endif

        precision lowp float;
        varying vec4 fragColor;

        void main() {
          float r = 0.0, delta = 0.0, alpha = 1.0;
          vec2 cxy = 2.0 * gl_PointCoord - 1.0;
          r = dot(cxy, cxy);

          #ifdef GL_OES_standard_derivatives
            delta = fwidth(r);
            alpha = 1.0 - smoothstep(1.0 - delta, 1.0 + delta, r);
          #endif

          gl_FragColor = fragColor * alpha;
        }

        /* void main() {
          if (length(gl_PointCoord.xy - 0.5) > 0.5) {
            discard;
          }
          gl_FragColor = fragColor;
        } */`,

      attributes: {
        positionStart: {
          buffer: this.pointBuffer,
          stride: VERT_SIZE,
          offset: 0
        },
        positionEnd: {
          buffer: this.pointBuffer,
          stride: VERT_SIZE,
          offset: 16
        },
        colorStart: {
          buffer: this.pointBuffer,
          stride: VERT_SIZE,
          offset: 32
        },
        colorEnd: {
          buffer: this.pointBuffer,
          stride: VERT_SIZE,
          offset: 48
        },
        size: {
          buffer: this.pointBuffer,
          stride: VERT_SIZE,
          offset: 64
        },
        freq: {
          buffer: this.pointBuffer,
          stride: VERT_SIZE,
          offset: 68
        },
        phase: {
          buffer: this.pointBuffer,
          stride: VERT_SIZE,
          offset: 74
        }
      },

      uniforms: {
        viewStart: () => this.stage.matrix.lookAt.start,
        viewEnd: () => this.stage.matrix.lookAt.end,
        projection: () => this.stage.matrix.perspective,
        time: ({ time }) => time - this.stage.startTime,
        elapsed: () => time
      },

      count: NUM_POINTS,
      primitive: 'points'
    })

    // Calculate the new matrix
    const t = 0.005 * tick // this.stage.rotationSpeed * tick

    if (this.stage.rotationAxis === 0) {
      // Look at - START
      this.stage.matrix.lookAt.start = mat4.lookAt(
        [], // out
        view.start[1], // eye
        view.start[2], // center
        view.start[3] // up
      )

      view.end[1][1] = 3 + this.scrollY * this.chronoHeight
      view.end[2][1] = 3 + this.scrollY * this.chronoHeight

      // Look at - END
      this.stage.matrix.lookAt.end = mat4.lookAt(
        [], // out
        [view.end[1][0], view.end[1][1], view.end[1][2]], // eye
        [view.end[2][0], view.end[2][1], view.end[2][2]], // center
        view.end[3] // up
      )
    } else if (this.stage.rotationAxis === 1) {
      // view.start[1][0] += Math.sqrt(1 - Math.pow(Math.sin(Math.sign(Math.sin(t))), 2))
      // view.start[1][2] += Math.sign(Math.sin(t)) * 0.6

      view.end[1][0] = 10 * Math.cos(t)
      view.end[1][2] = 10 * Math.sin(t)

      // Look at - START
      view.start = [
        [],
        [view.start[1][0], view.start[1][1], view.start[1][2]],
        view.start[2], // center
        view.start[3] // up
      ]
      this.stage.matrix.lookAt.start = mat4.lookAt(
        [],
        view.start[1],
        view.start[2],
        view.start[3]
      )

      // Look at - END
      this.stage.matrix.lookAt.end = mat4.lookAt(
        [], // out
        [view.end[1][0], view.end[1][1], view.end[1][2]], // eye
        view.end[2], // center
        view.end[3] // up
      )
    } else {
      // Look at - START
      this.stage.matrix.lookAt.start = mat4.lookAt(
        [], // out
        view.start[1], // eye
        view.start[2], // center
        view.start[3] // up
      )

      // Look at - END
      this.stage.matrix.lookAt.end = mat4.lookAt(
        [], // out
        view.end[1], // eye
        view.end[2], // center
        view.end[3] // up
      )
    }

    // We want to know the scroll position since the scrollama feature doesn't seem to work
    // calculate the progression percentage of the chronologie stage
    const chronologieHeightPct = 1 + 0.25 + 0.25 + 0.8 + 0.5 + 0.8 + 0.5
    this.scrollY =
      (window.scrollY - window.innerHeight * chronologieHeightPct) /
      (window.innerHeight * (chronologieHeightPct + 0.5 + 1 + 0.25 + 0.25) -
        window.innerHeight * chronologieHeightPct)

    // console.log(this.scrollY)

    this.drawLabels(tick, time)
    this.drawMarkers()
    this.drawHistoryMarkers()
    drawParticles()
  }

  drawRandomLabel() {
    const selectedGroup = labelsGroups[this.businessesGroupId]

    // Pick a new random point after a while
    console.log('NEW LABEL')
    this.labelContent.style.opacity = '0'

    // If no more points to pick in the random points list, create a new fresh list of points
    if (!selectedGroup.rdPoints || selectedGroup.rdPoints.length === 0) {
      selectedGroup.rdPoints = selectedGroup.points.reduce(
        (a, b, i) => [...a, { label: selectedGroup.labels[i], point: b }],
        []
      )
    }

    // Find a random point
    const labelid = Math.floor(Math.random() * selectedGroup.rdPoints.length)
    const rdPoint = selectedGroup.rdPoints[labelid]
    // Remove it from the list of points
    selectedGroup.rdPoints.splice(labelid, 1)

    // update the html
    setTimeout(() => {
      this.labelContent.style.opacity = '1'
      this.labelContent.innerHTML =
        `<div class='title'>${rdPoint.label.name}</div>` +
        `<div class="description">${rdPoint.label.desc}</div>`
      this.stage.selectedPointIndex = rdPoint.point
    }, 250)
  }

  drawLabels(tick, time) {
    if (this.state.showLabels && this.label) {
      // Store the last time we showed a point
      const stageTimeInSeconds = Math.round(time - this.stage.startTime)

      // Pick a new random point after a while
      if (
        stageTimeInSeconds % 2 === 0 &&
        stageTimeInSeconds !== this.stage.elapsedTime
      ) {
        this.stage.elapsedTime = stageTimeInSeconds
        this.drawRandomLabel()
      }

      // Calculate a matrix for the dom elements
      const matrix = mat4.multiply(
        [], // out
        this.stage.matrix.perspective,
        this.stage.matrix.lookAt.end
      )

      // compute a clipspace position
      const selectedPoint = points[this.stage.selectedPointIndex]

      const updatedPosition = [
        selectedPoint[4] +
          Math.cos(selectedPoint[17] * time * 0.1) * selectedPoint[17] * 0.1,
        selectedPoint[5] +
          Math.cos(selectedPoint[18] * time * 0.1) * selectedPoint[18] * 0.1,
        selectedPoint[6] +
          Math.cos(selectedPoint[19] * time * 0.1) * selectedPoint[19] * 0.1,
        selectedPoint[7] +
          Math.cos(selectedPoint[20] * time * 0.1) * selectedPoint[20] * 0.1
      ]

      const clipspace = this.transformVector(matrix, updatedPosition)

      // divide X and Y by W just like the GPU does.
      clipspace[0] /= clipspace[3]
      clipspace[1] /= clipspace[3]

      // convert from clipspace to pixels
      const pixelX = ((clipspace[0] * 0.5 + 0.5) * this.state.width) / dpi
      const pixelY = ((clipspace[1] * -0.5 + 0.5) * this.state.height) / dpi

      // Update the label position
      this.label.style.left = pixelX + 'px'
      this.label.style.top = pixelY + 'px'
      const cssPos = [
        pixelX < window.innerWidth / 2 ? 'left' : 'right',
        pixelY < window.innerHeight / 2 ? 'top' : 'bottom'
      ]
      this.label.className = 'label'
      this.label.classList.add(cssPos[0])
      this.label.classList.add(cssPos[1])
    }
  }

  drawMarkers() {
    if (
      this.state.showCircles &&
      document.getElementsByClassName('circle').length > 1
    ) {
      // We don't want to move the camera here
      const matrix = mat4.multiply(
        [], // out
        this.stage.matrix.perspective,
        mat4.lookAt(
          [],
          [view.end[1][0], view.end[1][1], view.end[1][2]], // eye
          view.end[2], // center
          view.end[3] // up
        )
      )

      // ! Should be calculated one time only
      const radius = [2.8, 1.4, 0.7]
      radius.map((radius, i) => {
        // compute a clipspace position
        const cs = this.transformVector(matrix, [0, radius, radius, 1])

        // divide X and Y by W just like the GPU does.
        cs[0] /= cs[3]
        cs[1] /= cs[3]

        // convert from clipspace to pixels
        const px = ((cs[0] * 0.5 + 0.5) * this.state.width) / dpi
        const py = ((cs[1] * -0.5 + 0.5) * this.state.height) / dpi

        // Calculate the radius
        const rad = Math.sqrt(
          Math.pow(px - this.state.width / dpi / 2, 2) +
            Math.pow(py - this.state.height / dpi / 2, 2)
        )

        // Update the marker size
        document.getElementsByClassName('circle')[i].style.width =
          rad * 2 + 'px'
        document.getElementsByClassName('circle')[i].style.height =
          rad * 2 + 'px'
      })
    }
  }

  drawHistoryMarkers() {
    const markerMargin = 1.9

    if (this.state.showHistoryMarkers) {
      // Calculate a matrix for the dom elements
      const matrix = mat4.multiply(
        [], // out
        this.stage.matrix.perspective,
        this.stage.matrix.lookAt.end
      )

      // compute a clipspace position
      Array.from(document.getElementsByClassName('history-marker')).map(
        (e, i) => {
          const updatedPosition = [
            0,
            this.chronoGroups[i] ? this.chronoGroups[i][1] + markerMargin : 0,
            0,
            1
          ]
          const clipspace = this.transformVector(matrix, updatedPosition)

          // divide X and Y by W just like the GPU does.
          clipspace[0] /= clipspace[3]
          clipspace[1] /= clipspace[3]

          // convert from clipspace to pixels
          const pixelX = (clipspace[0] * 0.5 + 0.5) * this.state.width
          const pixelY = (clipspace[1] * -0.5 + 0.5) * this.state.height

          // Update the label position
          e.style.left = pixelX / dpi + 'px'
          e.style.top = pixelY / dpi + 'px'
          // e.style.opacity = 0.5
        }
      )
    }
  }

  transformVector(m, v, dst) {
    dst = new Float32Array(4)
    for (let i = 0; i < 4; ++i) {
      dst[i] = 0.0
      for (let j = 0; j < 4; ++j) {
        dst[i] += v[j] * m[j * 4 + i]
      }
    }
    return dst
  }

  render() {
    return (
      <>
        <canvas
          id='dotsCanvas'
          width={this.state.width}
          height={this.state.height}
          style={{
            width: '100%',
            height: 'auto'
          }}
          ref={node => {
            this.canvas = node
          }}
        />
        {this.state.showCircles && (
          <div className='annotations'>
            <div className='circle'>
              <div className='circle-label'>3 ans</div>
            </div>
            <div className='circle'>
              <div className='circle-label'>6 ans</div>
            </div>
            <div className='circle'>
              <div className='circle-label'>20 ans</div>
            </div>
          </div>
        )}

        {this.state.showHistoryMarkers && (
          <div>
            <div className='history-marker'>
              <div className='circle-label'>1930</div>
              <div className='marker-dot line' />
            </div>
            <div className='history-marker'>
              <div className='circle-label'>1940</div>
              <div className='marker-dot line' />
            </div>
            <div className='history-marker'>
              <div className='circle-label'>1950</div>
              <div className='marker-dot line' />
            </div>
            <div className='history-marker'>
              <div className='circle-label'>1960</div>
              <div className='marker-dot line' />
            </div>
            <div className='history-marker'>
              <div className='circle-label'>1970</div>
              <div className='marker-dot line' />
            </div>
            <div className='history-marker'>
              <div className='circle-label'>1980</div>
              <div className='marker-dot line' />
            </div>
            <div className='history-marker'>
              <div className='circle-label'>1990</div>
              <div className='marker-dot line' />
            </div>
            <div className='history-marker'>
              <div className='circle-label'>2000</div>
              <div className='marker-dot line' />
            </div>
            <div className='history-marker'>
              <div className='circle-label'>2010</div>
              <div className='marker-dot line' />
            </div>
            <div className='history-marker'>
              <div className='circle-label'>2020</div>
              <div className='marker-dot line' />
            </div>
          </div>
        )}

        {this.state.showLabels && (
          <div
            className='label'
            ref={node => {
              this.label = node
            }}
          >
            <div className='marker'>
              <div className='marker-dot' />
            </div>
            <div
              className='content'
              ref={node => {
                this.labelContent = node
              }}
            />
          </div>
        )}
      </>
    )
  }
}

export default DotsCanvasRegl
